module.exports = __webpack_public_path__ + "img/icon-marker-accent-0.835ab64a.svg";